import React from "react";
// import { Pagination, PaginationLink, PaginationItem, Row, Col } from "reactstrap";
import Pagination from "@mui/material/Pagination";
import styled from "styled-components";

const DataTablePagination = ({ pageNumbers, page, setPage }) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <Wrapper>
      <p>
        Showing {((page-1)*10)+1} to {page * 10 >= pageNumbers ? pageNumbers : page * 10}{" "}
        of {pageNumbers} entries{" "}
      </p>
      <Pagination count={Math.ceil(pageNumbers/10)} page={page} onChange={handleChange} />
    </Wrapper>
  );
};
export default DataTablePagination;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
